import { render, staticRenderFns } from "./newHelp.vue?vue&type=template&id=2df950ac&scoped=true&"
import script from "./newHelp.vue?vue&type=script&lang=js&"
export * from "./newHelp.vue?vue&type=script&lang=js&"
import style0 from "./newHelp.vue?vue&type=style&index=0&id=2df950ac&prod&scoped=true&lang=scss&"
import style1 from "./newHelp.vue?vue&type=style&index=1&id=2df950ac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df950ac",
  null
  
)

export default component.exports